import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Connecting Gumroad to Auth0 for paywalled JAMStack apps",
  "description": "",
  "published": "2020-02-24T00:00:00.000Z",
  "redirect_from": ["/blog/connecting-gumroad-to-auth0-for-paywalled-jamstack-apps/swizec/9336"],
  "categories": "Back End, Front End, Technical",
  "hero": "./img/R1Nx5tx.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Lots of folks were curious how I connect Gummroad and Auth0 on `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-and-how-i-built-my-own-course-platform/swizec/9330"
      }}>{`my custom course platform`}</a>{` so here's a short tutorial. The same approach works if you swap Gumroad out for Stripe ✌️`}</p>
    <p>{`Here's the tl;dr:`}</p>
    <ol {...{
      "start": 0
    }}>
      <li parentName="ol">{`User visits your JAMStack app (Gatsby for me)`}</li>
      <li parentName="ol">{`User clicks Buy Button`}</li>
      <li parentName="ol">{`Gumroad checkout pops up`}</li>
      <li parentName="ol">{`User purchases`}</li>
      <li parentName="ol">{`Gumroad calls a webhook`}</li>
      <li parentName="ol">{`AWS Lambda wakes up, creates account on Auth0`}</li>
      <li parentName="ol">{`User is redirected back to JAMStack`}</li>
      <li parentName="ol">{`User can now login`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/bbe982bc4ce41970c26188068db48538/afd61/R1Nx5tx.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.09865470852019%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'344\\'%20viewBox=\\'0%200%20400%20344\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M50%2025a2505%202505%200%20001%2071c-1%2024-1%2031%203%2029l3%201%202%201-1-2c-2-1%2013-2%2024-1a393%20393%200%200061%201%201057%201057%200%2001-80-3c-12%201-11%202-10-18a735%20735%200%2000-3-79m4-19a563%20563%200%200173%206l30%202h8v5a1447%201447%200%2001-11%2080l-3%2021c-1%201-1%201%201%201%202-1%202-1%204-29a735%20735%200%200111-79A2170%202170%200%200154%206m234%2015l-3%2020c-7%2048-8%2059-8%2077v18h30l52%201%2022%202v-15c0-11%200-17%202-24a441%20441%200%200010-83%204919%204919%200%2001-75-2l-30-1v7m4-5c-2%200-3%202-4%2012l-2%2019c-5%2038-7%2052-7%2070l-1%2019%205-1h75l21%201v-9c-1-10%200-22%204-39%206-22%2012-68%2010-70l-48-1a1397%201397%200%2001-53-1m-75%206c-22%205-40%2011-43%2015-3%203-2%203%203-1%205-3%209-4%2026-9%2029-8%2054-4%2065%208%203%203%203%203%201%204s-3%204-1%204l5%202c5%204%207%201%205-9-1-6-2-5-2%201l1%204-6-6c-8-8-10-9-21-12-9-2-27-3-33-1M62%2024c-4%201%208%204%2021%204h10c8%201%2021-2%2019-4h-9c-5%202-10%202-12%202l-13-1a76%2076%200%2001-16-1m72%205c-5%201-7%203-6%204h2c1-1%201-1%201%206l1%205%205-1%2011-1%205-1V29l-7-1-12%201m177%202c-2%201-2%203-1%204l-1%204c-2%202-2%202%201%205%202%202%203%203%203%201%200-1%201-3%203-3%202-2%203-3%200-5v-4c1-2%201-3-2-3-1-1-2%200-3%201m-174%200c-2%200-4%205-4%209%200%203%201%203%2016-1%202%200%202-1%202-5v-4h-6l-8%201m191%202l-2%205c1%203%200%208-1%206-1-1-1-1-1%201s1%202%203%202l2%201v1c1%201%201%200%201-1l2-2c2-1%203-4%201-6-1-1%201-6%202-6l1-1-2-1-3-1-3%202m19-1c-3%201-3%203-2%205%202%202%201%209-1%207h-1c-1%201%202%203%204%203%201%200%202%201%201%202l1%202%201-3%202-3c2-1%203-5%201-6v-4c1-4-1-5-6-3m-247%206H90c-5-1-7-1-14%201l-11%202-3%202a195%20195%200%200151-2c3%200%204-2%202-3-5-2-12-2-15%200M90%2083l-6%202-2%201c0%203%202%203%208%200%204-3%205-3%206-2l4%202%206%201h23l2%201c5-3-6-9-13-7H98c0-2-6-1-8%202m75%209l-1%205-1%204v2c1%200%202-1%203-5v-4l2%203c3%205%2010%2010%2020%2015%2025%2012%2054%2012%2076%200%204-2%2010-7%2010-9s-2-1-3%202c-2%204-12%208-24%2012-11%203-30%203-42-1-11-2-39-18-33-18l2%201h5l-3-2c-2-1-5-2-6-4-3-2-3-2-5-1m-90%204c-10%202-12%203-10%204%201%201%201%202-1%207-4%2012-2%2014%2013%2010%2010-3%209-2%207-12l1-8c1-5%201-5-10-1m-1%202c-5%201-6%202-8%207s-3%2013-2%2013l7-2%2010-3c3%200%203%200%202-2v-9c0-7%200-7-9-4m223%2012v7c-2%203-2%205-1%206h1l2-7%201-5%2022%201%2032%201v6l-2%205h-21l2-2c7-5%2010-8%208-8l-3%202-4%201-2-1-1-2c-2%200-1%204%201%205%201%200%201%201-1%203-3%202-4%202-18%202l-16%201c-3%200-2%202%200%202%204-2%2054-1%2055%200s1%200%202-3l2-7c2-6-1-7-36-7h-23M59%20134c-4%203-7%203-5-1l-1-2-1%205%201%206h-3l-4-2-2%201%209%203%203-2c2-3%207-5%207-2l2%202c2%201%204%200%204-2%200-3%202-4%205-3%202%201%203%200%205-2l3-2v8c2%200%202-10%201-11l-3%202c-3%203-6%204-8%202-1-2-4%201-5%205s-2%202-2-3c0-7-1-7-6-2m280%2013c-1%204-1%206%202%206%204%201%208%200%2010-4%202-3%200-5-6-5-3%200-4%200-6%203m-234%2012l-3%204c-3%202-3%204%200%203l2-1v22a561%20561%200%20011%203l2-28c1-3%201-3%202%202%201%206%202%207%203%207%201-1-2-13-4-14l-3%202m-25%2017a15782%2015782%200%20015%2067c1%205-2%201-5-4-2-5-4-6-4-4l8%2012c2%200%207-11%206-13-1-1-1%200-2%203-2%206-3%205-3-6a7387%207387%200%2000-5-55m-41%2018l-3%201c-2-1-3%200-4%202-2%204-4%206-6%204v-3l-1-2c-2%201-2%206%200%207%202%202%206%200%208-2%202-4%206-4%206%200s2%204%202%200c1-3%202-4%204-4l2-2c0-1-7-2-8-1m166%207c-2%203-3%207%200%207l1-1c-2-2%204-6%208-6%203%200%204%201%205%204%203%206%203%206-5%2012-7%205-8%207-5%208l2-1%201-2%206-3%205-4%202%204%203%205c1%202%203%203%204%201l-4-8-4-8c-3-8-5-10-11-10l-8%202m35%2032l2%201%201%205-1%206%205-1c8%200%209-2%201-9-5-4-8-5-8-2m22%203l-6%207c-1%202%200%204%202%201l3-1%201-1c1-2%206%200%207%203l3%203-1-4-2-9c0-5-2-5-7%201m-37-3l1%202c2%200%202%202%202%204%200%204%200%205%203%206%206%203%2010%200%206-4-2-1-3-3-2-4%201-2-8-6-10-4m-48%2026l-16%207c-5%203-15%206-16%206l2-2c2%200%203-1%203-2%200-2-7%203-11%207l-3%203%2011-1%2012-1c1-1-15-1-19%201v-1l7-3%2015-6%2018-8c9-3%2013-5%2010-5l-13%205m-81%200h-4l-8%204c-5%204-5%204-5%2010l-1%2015a429%20429%200%2000-1%2028l4%202c8%205%2018%204%2028-1l9-4%201-6a680%20680%200%20004-44c-1%200-25-5-27-4m-2%203l-3%201c-1%201-1%202-4%202l-4%202c-2%202-2%202%200%204s4%202%2011%200l14-2c10-1%2015-3%2014-4-2-1-25-4-28-3m17%209l-16%202-10%202c-3-1-4%200-4%208%200%209%204%2011%2021%2011%2010%200%2015-2%2017-6s2-18%201-18l-9%201m-31%2025v5l-1%202-1%206-1%205%205%202c8%204%2016%204%2024%200%208-3%2011-7%2011-15l2-7c0-2%200-2-4%200-7%204-24%204-30%200l-5-3v5m42%2027c-4%203-5%205-2%207%204%203%2010%202%2013-3%201-2%201-2-1-4-3-3-6-2-10%200m-44%203v9c3%202%2010-1%2010-5l1-1%202-1c2%200%202%201%201%204l1%204%201-2c0-4%201-6%204-6s2-2-3-3-8%201-9%205l-4%203c-3%200-4-2-2-5%201-2%200-4-2-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/bbe982bc4ce41970c26188068db48538/ca0a1/R1Nx5tx.webp 223w", "/static/bbe982bc4ce41970c26188068db48538/75680/R1Nx5tx.webp 445w", "/static/bbe982bc4ce41970c26188068db48538/8d1ba/R1Nx5tx.webp 890w", "/static/bbe982bc4ce41970c26188068db48538/3838e/R1Nx5tx.webp 1335w", "/static/bbe982bc4ce41970c26188068db48538/9241d/R1Nx5tx.webp 1431w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/bbe982bc4ce41970c26188068db48538/e92b6/R1Nx5tx.png 223w", "/static/bbe982bc4ce41970c26188068db48538/e66bf/R1Nx5tx.png 445w", "/static/bbe982bc4ce41970c26188068db48538/4ef49/R1Nx5tx.png 890w", "/static/bbe982bc4ce41970c26188068db48538/4e814/R1Nx5tx.png 1335w", "/static/bbe982bc4ce41970c26188068db48538/afd61/R1Nx5tx.png 1431w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/bbe982bc4ce41970c26188068db48538/4ef49/R1Nx5tx.png",
              "alt": "R1Nx5tx",
              "title": "R1Nx5tx",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You can replace the Gumroad popup with a redirect to Stripe Checkout. We use that approach in the example app for my `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` course.`}</p>
    <p>{`If you want to support free trials, you can use the AWS Lambda to add a role for existing users instead of creating new accounts. That way people can login, use your app, and get extra permissions once they buy.`}</p>
    <p>{`You can watch me figure this out from scratch on a stream:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=lwaHKXItp2k"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M2%202L1%203l4%201c8%202%208%205%201%205H0v7h12c10%200%2013-1%2010-3v-2c1-1%20125-2%20131%200%202%200%202%201%202%203l-1%202h71v-4c0-3%200-3-4-3s-5-1-4-5l-3-1c-2%200-3%200-2%201v1h-1l-83-2C-4%203%205%203%205%202L3%200%202%202m188%20104l-1%207c0%206%201%207%2011%207%209%200%2010-1%2010-8v-6l-10-1-10%201m-70%2037l-4%202c-2%200-3%200-3%204v12H93l-19%201-1%209-2%2012c-1%202-4%203-2%201l-1-1-1%201c-1%201-2%202-6%202-4-1-6%200-7%201h-3l-1-1-1%206v5l-2-3h-1c-3%202-3%201-3-11%200-9%200-11%202-12l1-2%201-2%203-2%207-3-26-1H0v64h401v-33c0-31%200-31-1-5v28h-39l-42-1h-3v-69h-36c-32%200-36%200-37-2h-1c-1%202-5%202-54%202a731%20731%200%2001-68-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/90538f4e8295d4da83df9bcadc98a2b9/ca0a1/techletter.app-screenshot-1582560337594.webp 223w", "/static/90538f4e8295d4da83df9bcadc98a2b9/75680/techletter.app-screenshot-1582560337594.webp 445w", "/static/90538f4e8295d4da83df9bcadc98a2b9/0ba47/techletter.app-screenshot-1582560337594.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/90538f4e8295d4da83df9bcadc98a2b9/e92b6/techletter.app-screenshot-1582560337594.png 223w", "/static/90538f4e8295d4da83df9bcadc98a2b9/e66bf/techletter.app-screenshot-1582560337594.png 445w", "/static/90538f4e8295d4da83df9bcadc98a2b9/6af66/techletter.app-screenshot-1582560337594.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/90538f4e8295d4da83df9bcadc98a2b9/6af66/techletter.app-screenshot-1582560337594.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "start-with-a-buy-button"
    }}>{`Start with a buy button`}</h2>
    <p>{`Assuming you've got a JAMStack app – Gatsby, NextJS, or even CreateReactApp are all fine – a buy button is just a bit of React. I like to use `}<a parentName="p" {...{
        "href": "https://rebassjs.org/"
      }}>{`Rebass`}</a>{` buttons.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20React%20from%20'react'%0Aimport%20%7B%20Button%20%7D%20from%20%22rebass%22%0A%0Aconst%20BuyButton%20%3D%20(%7B%20gumroadID%2C%20cta%20%7D)%20%3D%3E%20(%0A%09%3CButton%0A%20%20%20%20as%3D%22a%22%0A%20%20%20%20href%3D%7B%60https%3A%2F%2Fgumroad.com%2Fl%2F%24%7BgumroadID%7D%3Fwanted%3Dtrue%60%7D%0A%20%20%20%20data-gumroad-product-id%3D%7BgumroadID%7D%0A%20%20%20%20data-gumroad-single-product%3D%22true%22%0A%20%20%20%20mx%3D%7B2%7D%0A%20%20%20%20sx%3D%7B%7B%0A%20%20%20%20%20%20%22%3Ahover%22%3A%20%7B%0A%20%20%20%20%20%20%20%20cursor%3A%20%22pointer%22%2C%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%7D%0A%20%20%3E%0A%20%20%20%20%7Bcta%7D%0A%20%20%3C%2FButton%3E%0A)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "89.23766816143497%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'356\\'%20viewBox=\\'0%200%20400%20356\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-3%202-3%20285%200%20287%202%202%20350%202%20352%200%203-2%203-285%200-287-2-3-350-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/684edf10470a334a1cd270f97bdc1953/ca0a1/techletter.app-screenshot-1582560335267.webp 223w", "/static/684edf10470a334a1cd270f97bdc1953/75680/techletter.app-screenshot-1582560335267.webp 445w", "/static/684edf10470a334a1cd270f97bdc1953/4e18f/techletter.app-screenshot-1582560335267.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/684edf10470a334a1cd270f97bdc1953/e92b6/techletter.app-screenshot-1582560335267.png 223w", "/static/684edf10470a334a1cd270f97bdc1953/e66bf/techletter.app-screenshot-1582560335267.png 445w", "/static/684edf10470a334a1cd270f97bdc1953/86389/techletter.app-screenshot-1582560335267.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/684edf10470a334a1cd270f97bdc1953/86389/techletter.app-screenshot-1582560335267.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This renders a button as a link tag, links to Gumroad, and enables the Gumroad popover. Users can purchase without leaving the page and if that doesn't work (no JS, weird browser, etc), they go to Gumroad's checkout page.`}</p>
    <p><img parentName="p" {...{
        "src": "/6573f5cf4e282628133443325e4b30bd/RtkfTmy.gif",
        "alt": null
      }}></img></p>
    <p>{`You'll need to include Gumroad's script tag on your page. `}<a parentName="p" {...{
        "href": "https://github.com/nfl/react-helmet"
      }}>{`ReactHelmet`}</a>{` works great for that.`}</p>
    <h2 {...{
      "id": "aws-lambda-webhook"
    }}>{`AWS Lambda Webhook`}</h2>
    <p>{`The webhook is where things get interesting.`}</p>
    <p>{`Gumroad supports a `}<a parentName="p" {...{
        "href": "https://gumroad.com/ping"
      }}>{`Gumroad Ping`}</a>{`, which is a POST request sent to a URL of your choice on every purchase. Stripe calls it a `}<a parentName="p" {...{
        "href": "https://stripe.com/docs/webhooks"
      }}>{`Stripe Webhook`}</a>{`.`}</p>
    <p>{`Webhooks let you do stuff on important events in 3rd party services. Creating a user in our case.`}</p>
    <p>{`I set my hook up using Serverless with AWS Lambda. NextJS's `}<inlineCode parentName="p">{`/api`}</inlineCode>{` directory would be a good choice too. Or Netlify's cloud functions. They're all the same thing – a JavaScript function that runs when a URL gets a POST request.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=yaml&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=service%3A%20serverlessreactdev%0A%0Aprovider%3A%0A%20%20name%3A%20aws%0A%20%20runtime%3A%20nodejs12.x%0A%09iamRoleStatements%3A%0A%20%20%20%20-%20Effect%3A%20Allow%0A%20%20%20%20%20%20Action%3A%0A%20%20%20%20%20%20%20%20-%20secretsmanager%3AGetSecretValue%0A%20%20%20%20%20%20Resource%3A%0A%20%20%20%20%20%20%20%20-%20Fn%3A%3AJoin%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20%22%3A%22%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20-%20arn%3Aaws%3Asecretsmanager%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20Ref%3A%20AWS%3A%3ARegion%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20Ref%3A%20AWS%3A%3AAccountId%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20secret%3A*%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0Afunctions%3A%0A%20%20gumroadping%3A%0A%20%20%20%20handler%3A%20dist%2FgumroadPing.pingHandler%0A%20%20%20%20events%3A%0A%20%20%20%20%20%20-%20http%3A%0A%20%20%20%20%20%20%20%20%20%20path%3A%20gumroadPing%0A%20%20%20%20%20%20%20%20%20%20method%3A%20POST%0A%20%20%20%20%20%20%20%20%20%20cors%3A%20true"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "143.9461883408072%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'576\\'%20viewBox=\\'0%200%20400%20576\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-1%20483%201%20485s334%202%20336%200%203-483%201-485-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33ae140b6f713b4778ad4d1024f70d3c/ca0a1/techletter.app-screenshot-1582560335311.webp 223w", "/static/33ae140b6f713b4778ad4d1024f70d3c/866c5/techletter.app-screenshot-1582560335311.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33ae140b6f713b4778ad4d1024f70d3c/e92b6/techletter.app-screenshot-1582560335311.png 223w", "/static/33ae140b6f713b4778ad4d1024f70d3c/05ed2/techletter.app-screenshot-1582560335311.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/33ae140b6f713b4778ad4d1024f70d3c/05ed2/techletter.app-screenshot-1582560335311.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This config creates a new service, uses Node 12, adds some permissions, and creates a `}<inlineCode parentName="p">{`gumroadping`}</inlineCode>{` AWS Lambda function.`}</p>
    <p>{`A benefit of using AWS directly is that you can use `}<a parentName="p" {...{
        "href": "https://aws.amazon.com/secrets-manager/"
      }}>{`AWS Secrets Manager`}</a>{` to securely store API keys and keep your infrastructure config in this one file.`}</p>
    <p><inlineCode parentName="p">{`sls deploy`}</inlineCode>{` spits out a URL. Gumroad sends a POST request and AWS runs your code.`}</p>
    <h3 {...{
      "id": "pinghandler"
    }}>{`pingHandler`}</h3>
    <p><inlineCode parentName="p">{`pingHandler`}</inlineCode>{` is where that work happens.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20qs%20from%20%22querystring%22%0A%0Aconst%20SR_PRODUCTS%20%3D%20%5B%0A%20%20%22https%3A%2F%2Fgum.co%2FIeDvq%22%2C%0A%20%20%22https%3A%2F%2Fgum.co%2FWTeMS%22%2C%0A%20%20%22https%3A%2F%2Fgumroad.com%2Fl%2FIeDvq%22%2C%0A%20%20%22https%3A%2F%2Fgumroad.com%2Fl%2FWTeMS%22%2C%0A%5D%0A%0Aexport%20const%20pingHandler%20%3D%20async%20(%0A%20%20event%3A%20APIGatewayEvent%0A)%3A%20Promise%3CAPIResponse%3E%20%3D%3E%20%7B%0A%20%20const%20ping%3A%20GumroadPing%20%3D%20qs.parse(event.body!)%20as%20any%0A%0A%20%20console.log(%22ping%20for%22%2C%20ping.product_permalink)%0A%0A%20%20if%20(SR_PRODUCTS.includes(ping.product_permalink))%20%7B%0A%20%20%20%20console.log(%22doing%20the%20thing%22)%0A%20%20%20%20const%20user%20%3D%20await%20upsertUser(ping)%0A%0A%20%20%20%20if%20(user)%20%7B%0A%20%20%20%20%20%20const%20auth0%20%3D%20await%20getAuth0Client()%0A%0A%20%20%20%20%20%20await%20auth0.assignRolestoUser(%0A%20%20%20%20%20%20%20%20%7B%20id%3A%20user.user_id!%20%7D%2C%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%2F%2F%20hardcoded%20Student%20role%20id%20from%20Auth0%20URL%0A%20%20%20%20%20%20%20%20%20%20roles%3A%20%5B%22rol_wyNa81ZMSaFU7wSW%22%5D%2C%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20)%0A%20%20%20%20%7D%0A%20%20%7D%0A%0A%20%20return%20response(200%2C%20%7B%7D)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "550px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "145.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'581\\'%20viewBox=\\'0%200%20400%20581\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036l-1%20255c0%20250%200%20254%202%20255%204%202%20349%201%20350-1%203-2%203-507%201-509S26%2034%2024%2036\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f2976983564a77d85a3dcc0008ed27ea/ca0a1/techletter.app-screenshot-1582560335327.webp 223w", "/static/f2976983564a77d85a3dcc0008ed27ea/75680/techletter.app-screenshot-1582560335327.webp 445w", "/static/f2976983564a77d85a3dcc0008ed27ea/12b65/techletter.app-screenshot-1582560335327.webp 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f2976983564a77d85a3dcc0008ed27ea/e92b6/techletter.app-screenshot-1582560335327.png 223w", "/static/f2976983564a77d85a3dcc0008ed27ea/e66bf/techletter.app-screenshot-1582560335327.png 445w", "/static/f2976983564a77d85a3dcc0008ed27ea/dd45a/techletter.app-screenshot-1582560335327.png 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f2976983564a77d85a3dcc0008ed27ea/dd45a/techletter.app-screenshot-1582560335327.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A couple things happen here:`}</p>
    <ol>
      <li parentName="ol">{`Parse request body with `}<inlineCode parentName="li">{`querystring`}</inlineCode></li>
      <li parentName="ol">{`Check product against a constant whitelist`}</li>
      <li parentName="ol">{`Create or update a user on Auth0 with `}<inlineCode parentName="li">{`upsertUser`}</inlineCode></li>
      <li parentName="ol">{`Add authorization role to user`}</li>
      <li parentName="ol">{`Say all went well`}</li>
    </ol>
    <p>{`We always return success and assume errors will throw. When your code throws AWS responds with a 500. That's fine.`}</p>
    <p>{`We're also hardcoding the `}<inlineCode parentName="p">{`Student`}</inlineCode>{` role because Auth0 doesn't work with role names and it's too much work to read the list, find the ID, and add that.`}</p>
    <p><img parentName="p" {...{
        "src": "/bc8b0cd17106308f06816cb5ae5db398/media-NTur7XlVDUdqM-giphy.gif",
        "alt": "this_is_fine giphy"
      }}></img></p>
    <p>{`Step 2 is important because Gumroad pings for all purchases. Wouldn't wanna give access to someone who bought a different product. 🙃`}</p>
    <p>{`As you can see this code is very scalable and generic. But it doesn't have to be. That's the beauty of cloud functions – they do one thing and one thing only.`}</p>
    <h3 {...{
      "id": "upsertuser"
    }}>{`upsertUser`}</h3>
    <p><inlineCode parentName="p">{`upsertUser`}</inlineCode>{` is where users get created or updated.`}</p>
    <p>{`Using upserts lets you support free trials and people who repurchase after a refund or whatever. Folks who have an account already.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20passwords%20from%20%22generate-password%22%0A%0Aasync%20function%20upsertUser(purchaseData%3A%20GumroadPing)%20%7B%0A%20%20const%20auth0%20%3D%20await%20getAuth0Client()%0A%0A%20%20const%20users%20%3D%20await%20auth0.getUsersByEmail(purchaseData.email)%0A%0A%20%20if%20(users.length%20%3E%200)%20%7B%0A%20%20%20%20return%20users%5B0%5D%0A%20%20%7D%20else%20%7B%0A%20%20%20%20return%20auth0.createUser(%7B%0A%20%20%20%20%20%20connection%3A%20%22Username-Pass-Auth%22%2C%0A%20%20%20%20%20%20email%3A%20purchaseData.email%2C%0A%20%20%20%20%20%20name%3A%20purchaseData.full_name%2C%0A%20%20%20%20%20%20password%3A%20passwords.generate(%7B%0A%20%20%20%20%20%20%20%20length%3A%2018%2C%0A%20%20%20%20%20%20%20%20numbers%3A%20true%2C%0A%20%20%20%20%20%20%20%20symbols%3A%20false%2C%0A%20%20%20%20%20%20%20%20excludeSimilarCharacters%3A%20true%2C%0A%20%20%20%20%20%20%7D)%2C%0A%20%20%20%20%7D)%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "96.41255605381164%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'385\\'%20viewBox=\\'0%200%20400%20385\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2033c-2%202-2%20318%200%20320s354%202%20356%200%202-318%200-320-354-2-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fcd67e991e6cde0896b97f53d78dc8a3/ca0a1/techletter.app-screenshot-1582560335371.webp 223w", "/static/fcd67e991e6cde0896b97f53d78dc8a3/75680/techletter.app-screenshot-1582560335371.webp 445w", "/static/fcd67e991e6cde0896b97f53d78dc8a3/18e7e/techletter.app-screenshot-1582560335371.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fcd67e991e6cde0896b97f53d78dc8a3/e92b6/techletter.app-screenshot-1582560335371.png 223w", "/static/fcd67e991e6cde0896b97f53d78dc8a3/e66bf/techletter.app-screenshot-1582560335371.png 445w", "/static/fcd67e991e6cde0896b97f53d78dc8a3/4d4a2/techletter.app-screenshot-1582560335371.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fcd67e991e6cde0896b97f53d78dc8a3/4d4a2/techletter.app-screenshot-1582560335371.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Get the Auth0 client, find user by email. If user exists, return, otherwise create a new user.`}</p>
    <p>{`For better security we generate a random secure password. Users have to go through the password reset flow on their first login.`}</p>
    <p>{`Makes the UX more cumbersome and the whole system more secure. You don't want to store these passwords and you don't want to send them by email. You also don't want them to be guessable.`}</p>
    <p>{`Infosec matters.`}</p>
    <h3 {...{
      "id": "getauth0client"
    }}>{`getAuth0Client`}</h3>
    <p><inlineCode parentName="p">{`getAuth0Client`}</inlineCode>{` is a helper method to instantiate an Auth0 client. Makes your code more readable :)`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%20ManagementClient%20%7D%20from%20%22auth0%22%0A%0Aasync%20function%20getAuth0Client()%20%7B%0A%20%20const%20secrets%20%3D%20await%20auth0Tokens()%0A%20%20const%20auth0%20%3D%20new%20ManagementClient(%7B%0A%20%20%20%20domain%3A%20%60%24%7Bsecrets.domain%7D.auth0.com%60%2C%0A%20%20%20%20clientId%3A%20secrets.clientId%2C%0A%20%20%20%20clientSecret%3A%20secrets.clientSecret%2C%0A%20%20%20%20scope%3A%20%22read%3Ausers%20update%3Ausers%20create%3Ausers%22%2C%0A%20%20%7D)%0A%0A%20%20return%20auth0%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "502px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "80.26905829596413%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'321\\'%20viewBox=\\'0%200%20400%20321\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-1%201-2%2021-2%20121%200%20119%200%20119%202%20121%203%203%20343%203%20346%200%202-2%202-2%202-121%200-100-1-120-2-121-1-2-14-2-173-2S28%2038%2027%2040\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/095c1f998d06e7221c9f41d71e29b2f9/ca0a1/techletter.app-screenshot-1582560335200.webp 223w", "/static/095c1f998d06e7221c9f41d71e29b2f9/75680/techletter.app-screenshot-1582560335200.webp 445w", "/static/095c1f998d06e7221c9f41d71e29b2f9/20682/techletter.app-screenshot-1582560335200.webp 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/095c1f998d06e7221c9f41d71e29b2f9/e92b6/techletter.app-screenshot-1582560335200.png 223w", "/static/095c1f998d06e7221c9f41d71e29b2f9/e66bf/techletter.app-screenshot-1582560335200.png 445w", "/static/095c1f998d06e7221c9f41d71e29b2f9/eea79/techletter.app-screenshot-1582560335200.png 502w"],
                "sizes": "(max-width: 502px) 100vw, 502px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/095c1f998d06e7221c9f41d71e29b2f9/eea79/techletter.app-screenshot-1582560335200.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Call `}<inlineCode parentName="p">{`getAuth0Tokens`}</inlineCode>{` to get secrets, instantiate a new `}<inlineCode parentName="p">{`ManagementClient`}</inlineCode>{` for Auth0. This one lets you manage users and stuff.`}</p>
    <h3 {...{
      "id": "auth0tokens"
    }}>{`auth0Tokens`}</h3>
    <p><inlineCode parentName="p">{`auth0Tokens`}</inlineCode>{` is a helper method to read API tokens and secrets from AWS Secrets Manager. This is important to avoid hardcoding secrets in your code, sharing them with other developers, and making sure they're secure at rest.`}</p>
    <p>{`You get a sort of triple-blind secret.`}</p>
    <p>{`Public can't see it. Developers can't see it. Servers can't see it. Secret only exists in memory at runtime. 🔐`}</p>
    <p>{`Attacking that would require an OS-level hack.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20AWS%20from%20%22aws-sdk%22%0A%0Aconst%20secrets%3A%20%7B%20%5Bkey%3A%20string%5D%3A%20Secret%20%7D%20%3D%20%7B%7D%0A%0Aexport%20const%20auth0Tokens%20%3D%20async%20()%20%3D%3E%20%7B%0A%20%20const%20SecretId%20%3D%20%22auth0APITokensServerlessReact%22%0A%20%20const%20ssm%20%3D%20new%20AWS.SecretsManager()%0A%20%20const%20data%20%3D%20await%20ssm%0A%20%20%20%20.getSecretValue(%7B%0A%20%20%20%20%20%20SecretId%2C%0A%20%20%20%20%7D)%0A%20%20%20%20.promise()%0A%0A%20%20if%20(!(%22SecretString%22%20in%20data))%20%7B%0A%20%20%20%20throw%20new%20Error(%60Error%20getting%20secret%20%24%7BSecretId%7D%60)%0A%20%20%7D%0A%0A%20%20if%20(data.SecretString)%20%7B%0A%20%20%20%20%2F%2F%20real%20production%20should%20expire%20this%20cache%0A%20%20%20%20secrets%5BSecretId%5D%20%3D%20JSON.parse(data.SecretString)%0A%20%20%7D%20else%20%7B%0A%20%20%20%20throw%20new%20Error(%60Error%20getting%20secret%20%24%7BSecretId%7D%60)%0A%20%20%7D%0A%0A%20%20return%20secrets%5BSecretId%5D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "542px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "117.48878923766817%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'470\\'%20viewBox=\\'0%200%20400%20470\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037c-2%202-2%20395%200%20397s348%202%20350%200%202-395%200-397c-2-3-348-3-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/92b935be60dd2eabefa0c259e9165222/ca0a1/techletter.app-screenshot-1582560335184.webp 223w", "/static/92b935be60dd2eabefa0c259e9165222/75680/techletter.app-screenshot-1582560335184.webp 445w", "/static/92b935be60dd2eabefa0c259e9165222/3f954/techletter.app-screenshot-1582560335184.webp 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/92b935be60dd2eabefa0c259e9165222/e92b6/techletter.app-screenshot-1582560335184.png 223w", "/static/92b935be60dd2eabefa0c259e9165222/e66bf/techletter.app-screenshot-1582560335184.png 445w", "/static/92b935be60dd2eabefa0c259e9165222/c0388/techletter.app-screenshot-1582560335184.png 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/92b935be60dd2eabefa0c259e9165222/c0388/techletter.app-screenshot-1582560335184.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Reads secret from AWS Secrets Manager, stores it in local variable for next time so you don't have to ping ASM every time you need a secret while your code runs.`}</p>
    <p>{`I should open source this 🤔`}</p>
    <h3 {...{
      "id": "an-important-sidenote"
    }}>{`An important sidenote`}</h3>
    <p>{`You'll need 2 Auth0 apps. This one took me for a spin. 😅`}</p>
    <p>{`1 app for your JAMStack frontend 1 app for your Lambda backend`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/28e3efb6b9afb79cfce802d052bc9ef0/5a190/HfAc1hu.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "22.421524663677133%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'90\\'%20viewBox=\\'0%200%20400%2090\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M179%2023v7l1%205h103V22h-52l-52%201m0%2043v6h104V60H179v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/28e3efb6b9afb79cfce802d052bc9ef0/ca0a1/HfAc1hu.webp 223w", "/static/28e3efb6b9afb79cfce802d052bc9ef0/75680/HfAc1hu.webp 445w", "/static/28e3efb6b9afb79cfce802d052bc9ef0/d00b9/HfAc1hu.webp 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/28e3efb6b9afb79cfce802d052bc9ef0/e92b6/HfAc1hu.png 223w", "/static/28e3efb6b9afb79cfce802d052bc9ef0/e66bf/HfAc1hu.png 445w", "/static/28e3efb6b9afb79cfce802d052bc9ef0/5a190/HfAc1hu.png 800w"],
              "sizes": "(max-width: 800px) 100vw, 800px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/28e3efb6b9afb79cfce802d052bc9ef0/5a190/HfAc1hu.png",
              "alt": "HfAc1hu",
              "title": "HfAc1hu",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "authenticate-and-authorize-users"
    }}>{`Authenticate and Authorize users`}</h2>
    <p>{`You're creating users for every purchase. Now what?`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` to handle authentication and authorization in your app.`}</p>
    <p>{`Assuming standard configuration from useAuth docs, you can paywall any component in your JAMStack app like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20candidate%20for%20useAuth%20feature%0Afunction%20isAuthorized(user)%20%7B%0A%20%20return%20user%5B%22https%3A%2F%2Fserverlessreact.dev%2Fuser_metadata%22%5D.roles.includes(%0A%20%20%20%20%22Student%22%0A%20%20)%0A%7D%0A%0Aconst%20Paywalled%20%3D%20()%20%3D%3E%20%7B%0A%09const%20%7B%20isAuthenticated%2C%20user%20%7D%20%3D%20useAuth()%0A%09%0A%09if%20(isAuthenticated()%20%26%26%20isAuthorized(user))%20%7B%0A%09%09return%20%3CSpecialContent%20%2F%3E%0A%09%7Delse%7B%0A%09%09return%20%3CBuyButton%20%2F%3E%0A%09%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "694px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.91928251121077%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'263\\'%20viewBox=\\'0%200%20400%20263\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029c-3%202-3%20204%200%20206%201%201%2030%202%20180%202s179-1%20180-2c3-2%203-204%200-206-2-3-358-3-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/73d2dd1a53d9bf30d2b9dce5083e9515/ca0a1/techletter.app-screenshot-1582560335386.webp 223w", "/static/73d2dd1a53d9bf30d2b9dce5083e9515/75680/techletter.app-screenshot-1582560335386.webp 445w", "/static/73d2dd1a53d9bf30d2b9dce5083e9515/181fb/techletter.app-screenshot-1582560335386.webp 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/73d2dd1a53d9bf30d2b9dce5083e9515/e92b6/techletter.app-screenshot-1582560335386.png 223w", "/static/73d2dd1a53d9bf30d2b9dce5083e9515/e66bf/techletter.app-screenshot-1582560335386.png 445w", "/static/73d2dd1a53d9bf30d2b9dce5083e9515/31198/techletter.app-screenshot-1582560335386.png 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/73d2dd1a53d9bf30d2b9dce5083e9515/31198/techletter.app-screenshot-1582560335386.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`useAuth`}</inlineCode>{` handles the Auth0 authentication lifecycle and returns an `}<inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` method and a `}<inlineCode parentName="p">{`user`}</inlineCode>{` object.`}</p>
    <p>{`Call `}<inlineCode parentName="p">{`isAuthenticated`}</inlineCode>{` to see if user is logged in with a valid session, use `}<inlineCode parentName="p">{`isAuthorized`}</inlineCode>{` to verify they've got the right role. Then let them through.`}</p>
    <p>{`Otherwise show them the buy button.`}</p>
    <h3 {...{
      "id": "tell-auth0-to-include-role-metadata"
    }}>{`Tell Auth0 to include role metadata`}</h3>
    <p>{`You'll have to add an `}<a parentName="p" {...{
        "href": "https://auth0.com/docs/rules"
      }}>{`Auth0 Rule`}</a>{` that includes user roles in response data to your Auth0 config.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20(user%2C%20context%2C%20callback)%20%7B%0A%20%20const%20namespace%20%3D%20'https%3A%2F%2Fserverlessreact.dev'%3B%0A%20%20const%20assignedRoles%20%3D%20(context.authorization%20%7C%7C%20%7B%7D).roles%3B%0A%20%20%0A%20%20user.user_metadata%20%3D%20user.user_metadata%20%7C%7C%20%7B%7D%3B%0A%0A%20%20user.user_metadata.roles%20%3D%20assignedRoles%3B%0A%0A%20%20context.idToken%5Bnamespace%20%2B%20'%2Fuser_metadata'%5D%20%3D%20user.user_metadata%3B%0A%0A%20%20callback(null%2C%20user%2C%20context)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "654px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "58.744394618834086%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'235\\'%20viewBox=\\'0%200%20400%20235\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2030a2448%202448%200%20000%20175c3%203%20357%203%20360%200l1-87-1-88c-1-2-359-2-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1fc28f65e4b2e727b90565a6afdaa5f5/ca0a1/techletter.app-screenshot-1582560335286.webp 223w", "/static/1fc28f65e4b2e727b90565a6afdaa5f5/75680/techletter.app-screenshot-1582560335286.webp 445w", "/static/1fc28f65e4b2e727b90565a6afdaa5f5/d7085/techletter.app-screenshot-1582560335286.webp 654w"],
                "sizes": "(max-width: 654px) 100vw, 654px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1fc28f65e4b2e727b90565a6afdaa5f5/e92b6/techletter.app-screenshot-1582560335286.png 223w", "/static/1fc28f65e4b2e727b90565a6afdaa5f5/e66bf/techletter.app-screenshot-1582560335286.png 445w", "/static/1fc28f65e4b2e727b90565a6afdaa5f5/68e9c/techletter.app-screenshot-1582560335286.png 654w"],
                "sizes": "(max-width: 654px) 100vw, 654px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1fc28f65e4b2e727b90565a6afdaa5f5/68e9c/techletter.app-screenshot-1582560335286.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This was the smallest code that works for me. Cobbled together from online discussions, a few blogs, and some trial and error.`}</p>
    <p>{`I didn't dive too much into details and I don't know why Auth0 doesn't include `}<inlineCode parentName="p">{`meta_data`}</inlineCode>{` by default.`}</p>
    <p><img parentName="p" {...{
        "src": "/ede06cab596cb780947104e17adbc91b/media-JRhS6WoswF8FxE0g2R-giphy.gif",
        "alt": "shrug giphy"
      }}></img></p>
    <h3 {...{
      "id": "bonus-ux-points"
    }}>{`Bonus UX points`}</h3>
    <p>{`For bonus UX points, you should give people temporary access when they come back from that Gumroad purchase.`}</p>
    <p>{`Gumroad gives you specific URL params that mean `}<em parentName="p">{`"This user just bought your course"`}</em>{`. Would be great if they didn't have to then login, change their password, and go through a bazillion steps just to get access.`}</p>
    <p>{`It's the approach I use on `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`ServerlessHandbook.dev`}</a>{` where there's no logins. Just local storage after a Gumroad redirect.`}</p>
    <p>{`Just add a check ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=if%20((isAuthenticated()%20%26%26%20isAuthorized(user))%20%7C%7C%20justBackFromGumroad())"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "670px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "27.802690582959645%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'112\\'%20viewBox=\\'0%200%20400%20112\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2031c-2%203-1%2051%200%2052%202%202%20358%202%20360%200%201-1%202-49%200-52-1-3-359-3-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb7af605bfcb4a2128b626fa92ec647b/ca0a1/techletter.app-screenshot-1582560335270.webp 223w", "/static/fb7af605bfcb4a2128b626fa92ec647b/75680/techletter.app-screenshot-1582560335270.webp 445w", "/static/fb7af605bfcb4a2128b626fa92ec647b/6cceb/techletter.app-screenshot-1582560335270.webp 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fb7af605bfcb4a2128b626fa92ec647b/e92b6/techletter.app-screenshot-1582560335270.png 223w", "/static/fb7af605bfcb4a2128b626fa92ec647b/e66bf/techletter.app-screenshot-1582560335270.png 445w", "/static/fb7af605bfcb4a2128b626fa92ec647b/d67fd/techletter.app-screenshot-1582560335270.png 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fb7af605bfcb4a2128b626fa92ec647b/d67fd/techletter.app-screenshot-1582560335270.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Make `}<inlineCode parentName="p">{`justBackFromGumroad`}</inlineCode>{` check the URL query :)`}</p>
    <h2 {...{
      "id": "️"
    }}>{`✌️`}</h2>
    <p>{`And that's how you can paywall parts of your JAMStack app.`}</p>
    <p>{`To learn more about these techniques, check out `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`ServerlessHandbook.Dev`}</a>{` and my new course `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      